/**
 * Moving the ledger between this device and the cloud — one copy at a time,
 * with tenantdb's move helpers (tenantdb-js): copy the whole file,
 * prove it by counting every table on both sides, and only then destroy the
 * copy it came from.
 *
 * The move is recorded in localStorage (`okane.move`) before anything is
 * destroyed, so a move cut short picks up where it stopped on the next start:
 *   { to: 'cloud', stage: 'copy' | 'erase' }  the device's ledger is going up
 *   { to: 'local', org }                      it came down; `org` is left to delete
 */
import { MoveError, asRollbackFile, copyDatabase, hasData, moves, tableCounts } from 'tenantdb/move'

const record = moves('okane')

/** The move under way, or null. */
export const pendingMove = () => record.get()
export const setPendingMove = (move) => record.set(move)
export const clearPendingMove = () => record.clear()

export { MoveError, asRollbackFile, tableCounts }

/** Copies the whole ledger and proves it arrived (tenantdb's copyDatabase). */
export const copyLedger = copyDatabase

/** Tables that say nothing about whether there is a ledger: bookkeeping and preferences. */
const NOT_LEDGER = ['_migrations', 'settings']

/** Whether these counts hold anything worth keeping — a preference alone is not a ledger. */
export const hasLedger = (counts) => hasData(counts, NOT_LEDGER)

/** How many transactions, for saying what would be replaced. */
export const transactionsIn = (counts) => counts.transactions ?? 0
